import { AssignmentTurnedIn } from "@mui/icons-material";
import ApiIcon from "@mui/icons-material/Api";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import PersonIcon from "@mui/icons-material/Person";
import ShareIcon from "@mui/icons-material/Share";
import StoreIcon from "@mui/icons-material/Store";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import { Box, BoxProps, styled, useTheme } from "@mui/material";
import { ListNavigation } from "common";
import I18n from "i18n-js";
import SidebarMenuItem from "layouts/SidebarMenuItem";
import { PERMISSIONS } from "../../app/constants";
import useAccess from "../../features/profile/useAccess";
import useWaiverMenuItems from "../../features/waivers/useWaiverMenuItems";

export interface GroupProps extends BoxProps {
  open?: boolean;
}

const Group = styled(Box)<GroupProps>(props => ({
  backgroundColor: "transparent",
  borderRadius: 0,
  marginLeft: props.theme.spacing(props.open ? 2 : 1),
  marginRight: props.theme.spacing(props.open ? 2 : 1),
}));

export interface AdminSidebarMenuProps {
  open?: boolean;
  setOpen?: (open?: boolean) => void;
  temporary?: boolean;
}
export default function AdminSidebarMenu({
  open,
  temporary,
}: AdminSidebarMenuProps) {
  const theme = useTheme();
  const { hasPermissions } = useAccess();
  const { waivers } = useWaiverMenuItems({
    enabled: hasPermissions(PERMISSIONS.MANAGE_WAIVERS),
  });

  return (
    <Box
      sx={
        temporary
          ? {
              flex: 1,
              display: "flex",
              flexDirection: "column",
              backgroundColor: theme.palette.background.default,
              borderTopRightRadius: 0,
              pt: 2,
            }
          : {
              pt: 2,
              flex: 1,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "transparent",
            }
      }
    >
      <Group open={open}>
        <ListNavigation minimized={!open} pattern="/">
          <SidebarMenuItem
            label={I18n.t("MyAccount.title")}
            value=""
            icon={<PersonIcon />}
            visible
            /*selectedOverried={
              location.pathname === "/" ||
              ["/plans", "/manage-payments", "/order"].indexOf(
                location.pathname
              ) > -1
            }*/
          />
          <SidebarMenuItem
            label={I18n.t("Submit.title")}
            value="submits"
            icon={<AssignmentTurnedIn />}
            visible={hasPermissions(PERMISSIONS.MANAGE_SUBMITS)}
          />
        </ListNavigation>
      </Group>
      <Group open={open}>
        {hasPermissions(PERMISSIONS.MANAGE_WAIVERS) ? (
          <ListNavigation
            open
            minimized={!open}
            pattern="/waivers"
            grouped
            groupTitle={I18n.t("Waiver.title").substring(
              0,
              open ? undefined : 1
            )}
            groupIcon={<NoteAltIcon />}
          >
            {waivers.map(waiver => (
              <SidebarMenuItem
                key={waiver.id}
                label={waiver.name}
                value={`waivers/${waiver.id}`}
                visible={hasPermissions(PERMISSIONS.MANAGE_SUBMITS)}
                sx={{
                  ml: "32px!important",
                  pl: "8px!important",
                  "& .MuiListItemText-primary": {
                    color: theme => `${theme.palette.text.primary}!important`,
                  },
                }}
              />
            ))}
            <SidebarMenuItem
              label={I18n.t("Waiver.allTitle")}
              value="waivers"
              visible={hasPermissions(PERMISSIONS.MANAGE_WAIVERS)}
              sx={{ ml: "32px!important", pl: "8px!important" }}
            />
          </ListNavigation>
        ) : (
          ""
        )}
      </Group>
      <Group open={open}>
        <ListNavigation minimized={!open} pattern="/">
          <SidebarMenuItem
            label={I18n.t("Sharing.title")}
            value="sharings"
            icon={<ShareIcon />}
            visible={hasPermissions(PERMISSIONS.VIEW_SHARINGS)}
          />
          <SidebarMenuItem
            label={I18n.t("Location.title")}
            value="locations"
            icon={<StoreIcon />}
            visible={hasPermissions(PERMISSIONS.MANAGE_LOCATIONS)}
          />
          <SidebarMenuItem
            label={I18n.t("Support.title")}
            to="https://support.signwaivers.com"
            target="_blank"
            icon={<SupportAgentIcon />}
            visible={hasPermissions(PERMISSIONS.MANAGE_LOCATIONS)}
          />
          <SidebarMenuItem
            label={I18n.t("OpenapiKey.title")}
            value="openapi-keys"
            icon={<ApiIcon />}
            visible={hasPermissions(PERMISSIONS.MANAGE_OPENAPIS)}
          />
          <SidebarMenuItem
            label={I18n.t("OpenapiKey.docs")}
            value="openapi-docs"
            icon={<ApiIcon />}
            visible={hasPermissions(PERMISSIONS.MANAGE_OPENAPIS)}
          />
        </ListNavigation>
      </Group>
      <Box flex={1}></Box>
    </Box>
  );
}
